import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const CardTitle = ({ linkTo, title, altText }) => (
  <div className='card-name col-12 mt-0 p-0'>
    <h2 className='txt-body-sm color-ui-2 txt-font-body txt-left'>
      <Link to={linkTo} aria-label={altText || title}>
        {title}
      </Link>
    </h2>
  </div>
)

CardTitle.propTypes = {
  linkTo: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  altText: PropTypes.string
}

export default CardTitle



// WEBPACK FOOTER //
// ./src/features/Availability/ProductCard/CardTitle/index.js